import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/layout/brands/facebook.svg")